module.exports = __webpack_public_path__ + "img/1c.652ec6a9.svg";